import React, {useState, useEffect} from 'react'
import {Modal} from 'react-bootstrap'
import {connect} from 'react-redux';
import {create_faq, get_faq, update_faq} from '../../redux/actions/adminActions';
import InputField from '../reusables/input';
import Spinner from '../reusables/spinner';

function CreateFaq({
    show,
    handleClose,
    supplier,
    edit,
    createFaq,
    accessToken,
    getFaq,
    id,
    updateFaq
}) {

    const [state,
        setState] = useState({
        question: '',
        answer: '',
        type: supplier
            ? 'supplier'
            : 'customer',
        status: ''
    })

    const [loading,
        setLoading] = useState(false);

    const handleChange = (e) => {
        setState({
            ...state,
            [e.target.name]: e.target.value
        });
    }

    const handleSuccess = () => {
        setLoading(false);
        handleClose();
    }

    const handleSubmit = (status) => {
        setLoading(true);
        createFaq(state, status, accessToken,  handleSuccess)
    }

    const handleUpdate = (e) => {
        e.preventDefault();

        setLoading(true);
        updateFaq(id, state, accessToken, handleSuccess);
    }

    useEffect(() => {
        if (edit) {
            getFaq(id, accessToken, (data) => setState(data))
        }
    }, [edit, id])

    return (
        <Modal show={show} onHide={handleClose} centered>
            <div className="container p-4">
                <h2 className="sectionHead--small">{edit
                        ? 'Edit an FAQ'
                        : 'Create a new FAQ '}
                    -
                    <span className="mx-2 textIsGreen">{supplier
                            ? 'Supplier'
                            : 'Customer'}</span>
                </h2>

                <form className="mt-4">
                    <div className="my-3">
                        <InputField
                            label="Question"
                            name='question'
                            value={state.question}
                            onChange={handleChange}/>
                    </div>

                    <div className="my-3">
                        <InputField
                            label="Answer"
                            name="answer"
                            value={state.answer}
                            onChange={handleChange}
                            textarea/>
                    </div>

                    <div className="mt-3 rAlign">
                        {!edit && <div >
                            <button
                                className="btn__transparent mx-3"
                                onClick={() => handleSubmit('inactive')}
                                disabled={ loading }>{ loading ? <Spinner/> : 'Save'}</button>
                            <button
                                className="btn__filled btn__long hasRadius"
                                onClick={() => handleSubmit('active')}
                                disabled={ loading }>{ loading ? <div className="center"><Spinner/> </div>: 'Save & Publish'}</button>
                        </div>
}

                        { edit && <button className="btn__filled hasRadius" onClick={ handleUpdate } disabled={ loading }>
                         { loading ? <div className="center"><Spinner/> </div>: 'Save'}
                        </button>}
                    </div>

                </form>
            </div>
        </Modal>
    )
}

const mapStateToProps = (state) => ({accessToken: state.admin.token})

const mapDispatchToProps = (dispatch) => ({
    createFaq: (data, status, token, success) => dispatch(create_faq(data, status, token, success)),
    getFaq: (id, token, success) => dispatch(get_faq(id, token, success)),
    updateFaq: (id, data, token, success) => dispatch(update_faq(id, data, token, success))
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateFaq);
